import DeleteIcon from "@mui/icons-material/Delete";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import {
  IconButton,
  TableCell,
  TableRow,
  TextField,
  Tooltip,
} from "@mui/material";
import React from "react";
import { Draggable } from "react-beautiful-dnd";
import { SelectOption } from "./OptionsSection";

type FieldOptionRowProps = {
  option: SelectOption;
  index: number;
  onClickDeleteOption: (
    index: number
  ) => (event: React.MouseEvent<HTMLButtonElement>) => void;
  showLabels: boolean;
  onChangeOption: (index: number, newOption: SelectOption) => void;
};

const FieldOptionRow: React.FC<FieldOptionRowProps> = ({
  option,
  index,
  onClickDeleteOption,
  showLabels,
  onChangeOption,
}) => {
  return (
    <Draggable key={`${index}`} draggableId={`${index}`} index={index}>
      {(draggableProvider) => (
        <TableRow
          ref={draggableProvider.innerRef}
          {...draggableProvider.draggableProps}
          {...draggableProvider.dragHandleProps}
          sx={{ userSelect: "none" }}
        >
          <TableCell padding="none">
            <IconButton size="small" edge="start">
              <DragIndicatorIcon />
            </IconButton>
          </TableCell>
          <TableCell width={showLabels ? "50%" : "100%"}>
            <TextField
              fullWidth
              value={option.value}
              size="small"
              name="value"
              error={!option.value}
              helperText={!option.value && "Required"}
              onChange={(event) =>
                onChangeOption(index, {
                  ...option,
                  [event.target.name]: event.target.value,
                })
              }
            />
          </TableCell>
          {showLabels && (
            <TableCell width={"50%"}>
              <TextField
                fullWidth
                value={option.label}
                size="small"
                name="label"
                onChange={(event) =>
                  onChangeOption(index, {
                    ...option,
                    [event.target.name]: event.target.value,
                  })
                }
              />
            </TableCell>
          )}
          <TableCell padding="none" align="right">
            <Tooltip title="Delete Option">
              <IconButton size="small" onClick={onClickDeleteOption(index)}>
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </TableCell>
        </TableRow>
      )}
    </Draggable>
  );
};

export default FieldOptionRow;
